export const paths = {
    home: '/',
    privacyPolicy: '/privacy-policy',
    Tnc: '/terms-of-use',
    aboutUs: '/about-us',
    ourLeadership: '/our-leadership',
    businessConcept: '/business-concept',
    whyFinoptsys: '/why-finoptsys',
    contactUs: '/contact-us'
}